import '/index.scss';
// import SiteHeader from './ts/modules/site-header';
import ReservationForm from './ts/modules/reservation-form';
import GalleryBlock from './ts/modules/gallery-block';
import BundleComparison from './ts/modules/bundle-comparison';
import DiscountBlock from './ts/modules/discount-block';
import Form from './ts/modules/form';
import * as Sentry from '@sentry/browser';

function init() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tunnel: '/sentry',
  });

  const swiperElements = document.querySelectorAll('.swiper') as NodeListOf<HTMLElement>;
  swiperElements.forEach((swiperWrapper) => {
    new GalleryBlock(swiperWrapper);
  })
  
  const reservationForm = document.getElementById('reservation-form');
  if(reservationForm instanceof HTMLFormElement) {
    new ReservationForm(reservationForm);
  }

  const loginForm = document.getElementById('locked-pages-login-form');
  if(loginForm instanceof HTMLFormElement) {
    new Form(loginForm);
  }

  const bundleComparisonWrapper = document.querySelector('.block-bundle-comparison');
  if(bundleComparisonWrapper instanceof HTMLElement) {
    new BundleComparison(bundleComparisonWrapper);
  }

  document.querySelectorAll('.button-history-back').forEach(backLink => {
    backLink.setAttribute('href', document.referrer);
  })

  const discountBlocks = document.querySelectorAll('.block-discount') as NodeListOf<HTMLButtonElement>;
  discountBlocks.forEach(discountBlockButton => {
    new DiscountBlock(discountBlockButton);
  });
}

// run once when page loads
if (document.readyState === 'complete') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', () => init());
}